/*
 * Module for handling individual substitution group
 */

define([
  "marionette",
  "messaging/messenger",
  "modules/substitutions/substitutionGroup/substitutionGroupView",
  "modules/substitutions/substitutionGroup/substitutionGroupInfo/substitutionGroupInfoModule",
  "modules/substitutions/substitutionGroup/substitutionGroupEntries/substitutionGroupEntriesModule",
  "modules/shared/sortableList/sortableListModule",
], function (
  Marionette,
  Messenger,
  SubstitutionGroupView,
  SubstitutionGroupInfoModule,
  SubstitutionGroupEntriesModule,
  SortableListModule,
) {
  var SubstitutionGroupController = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "substitutionGroup";
      this.region = options.region;
      this.subGroup = null;
      this._setUpVents();
    },
    show: function (subGroup) {
      console.log("show");
      this.layout = new SubstitutionGroupView.substitutionGroupLayout();
      this.subGroup = subGroup;
      //if validation fails, call the appropriate functions to display the error
      this.subGroup.on(
        "invalid",
        function (model, error) {
          if ("name" in error) {
            this.substitutionGroupInfo.nameError(error["name"]);
          }
          if ("entries" in error) {
            this.substitutionGroupEntries.emptyError(error["entries"]);
          }
        },
        this,
      );

      //listen for a change to the subGroup name
      //if the group is new and empty, then add an entry to the group with the same name as the group and set
      //it to auto apply
      if (this.subGroup.isNew()) {
        this.subGroup.once(
          "enter:name",
          function () {
            var entries = this.subGroup.entries();
            if (entries.length === 0) {
              //add an entry
              var newEntry = entries.addNewEntry();
              newEntry.set("entrySurfaceForm", this.subGroup.get("name"));
              newEntry.set("defaultEntry", true);
            }
          },
          this,
        );
      }

      this.substitutionGroupInfo = this.addSubModule(
        new SubstitutionGroupInfoModule({
          region: this.layout.substitutionGroupInfo,
          model: subGroup,
        }),
      );
      this.substitutionGroupEntries = this.addSubModule(
        new SubstitutionGroupEntriesModule({ region: this.layout.substitutionGroupEntries }),
      );

      this.layout.on(
        "show",
        function () {
          this._showSubViews(subGroup);
        },
        this,
      );

      this.showRegion(this.layout);
    },
    _showSubViews: function (subGroup) {
      this.substitutionGroupInfo.show();
      this.substitutionGroupEntries.show(subGroup.entries());
    },
    _setUpVents: function () {
      Messenger.vent.on(
        "sub:list:item:selected",
        function (subGroup) {
          this.show(subGroup);
        },
        this,
      );

      Messenger.vent.on(
        "delete:group",
        function () {
          //reset region view
          this.region.reset();
          this.subGroup = null; //disconnect sub group from module
        },
        this,
      );
      Messenger.vent.on(
        "show:history",
        function () {
          console.log("load history");
          //create modal with history
          const history = this.subGroup.history();
          const headers = Messenger.reqres.request("substitution:history:headers");
          Messenger.vent.trigger(
            "show:modal",
            SortableListModule,
            {
              headers: headers,
              hideControls: true,
              namespace: "subGroupHistory",
            },
            history,
            {
              title: "substitutions.history.title",
              closeButton: true,
              closeOnBackgroundClick: true,
              modalHeight: 600,
              trackInteraction: {
                action: "Substitution Group History",
                id: this.subGroup.id,
                idType: "Substitution Group",
                object: "Substitution Group",
              },
            },
          );
        },
        this,
      );
      //place this call in the setVents function so that it's available even if there isn't a group being shown
      Messenger.onSave(function () {
        console.log("saving group");
        if (this.subGroup !== null) {
          this.subGroup.saveModel();
        } else {
          console.log("nothing to save");
          //nothing to save, so fire a successful save attempt
          Messenger.saveAttempted(true);
        }
      }, this);
    },
  });

  return SubstitutionGroupController;
});
